import type { Translations } from "../types";

const de: Translations = {
  "meta.title": "Klicks pro Land – Weltkarte",
  "meta.description":
    "Interaktive Weltkarte: kostenlose Klicks pro Land sowie bezahlte Unterstützung über Stripe, PayPal und Buy Me a Coffee.",

  "app.title": "Klicks pro Land – Weltkarte",

  "map.intro":
    "Klicke auf ein Land auf der Karte, um ihm eine kostenlose Stimme zu geben, oder unterstütze es finanziell - beides zählt für die kombinierte Rangliste unten. Die Karte spiegelt nur die Unterstützung innerhalb dieser App wider, nicht den tatsächlichen Nationalreichtum oder das BIP.",
  "map.verifying": "Wird überprüft …",
  "map.confirmNotRobot": "Bevor du kostenlose Klicks hinzufügen kannst, bestätige kurz, dass du kein Roboter bist:",
  "map.tryAgain": "Erneut versuchen",
  "map.registeringClick": "Klick wird registriert …",
  "map.selectedCountry": "Ausgewähltes Land: {name}.",
  "map.selectFirstFeedback": "Land ausgewählt. Um einen kostenlosen Klick hinzuzufügen, bestätige zuerst unten, dass du kein Roboter bist.",
  "map.verificationExpired": "Die Überprüfung ist abgelaufen - bestätige erneut, dass du kein Roboter bist.",
  "map.slowDown": "Etwas langsamer - warte einen Moment vor deinem nächsten Klick.",
  "map.clickFailed": "Der Klick konnte nicht registriert werden. Bitte versuche es erneut.",
  "map.clickErrorGeneric": "Fehler beim Registrieren des Klicks.",
  "map.leaderboardHeading": "Länder-Rangliste",
  "map.emptySelection": "Wähle ein Land auf der Karte aus, um es zu unterstützen oder ihm einen Klick zu geben.",
  "map.loadingData": "Daten werden geladen …",

  "worldmap.loadError": "Die Karte konnte nicht geladen werden.",
  "worldmap.resetZoom": "Zoom zurücksetzen",
  "worldmap.resetButton": "⤾ Zurücksetzen",
  "worldmap.loadingMap": "Karte wird geladen …",
  "worldmap.unknownCountry": "Unbekannt",
  "worldmap.ariaClicks": "{name}: {clicks} Klicks",
  "worldmap.tooltipClicks": "{clicks} Klicks",

  "legend.fewer": "Weniger Klicks",
  "legend.more": "Mehr Klicks",

  "list.empty": "Noch keine Klicks. Sei der Erste!",
  "list.ariaLabel": "Länder-Rangliste nach Klicks",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY ist nicht gesetzt - siehe README zur Konfiguration.",
  "human.verificationFailedGeneric": "Überprüfung fehlgeschlagen.",
  "human.networkError":
    "Überprüfung nicht erreichbar (Netzwerkfehler) - prüfe VITE_SUPABASE_URL, ob verify-human bereitgestellt ist, und ALLOWED_ORIGIN; siehe README/NAVODILA.",
  "human.verificationFailedRetry": "Überprüfung fehlgeschlagen, versuche es erneut.",

  "provider.stripe": "💳 Karte (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Ausgewähltes Land",
  "panel.currentlyRanked": "Aktuell auf Platz #{rank}",
  "panel.shareCopied": "Kopiert ✓",
  "panel.shareShared": "Geteilt ✓",
  "panel.shareButton": "🔗 Teilen",

  "panel.tableClicks": "Klicks",
  "panel.tableFree": "Kostenlos",
  "panel.tablePaid": "Bezahlt",
  "panel.rowAllTime": "Gesamt",
  "panel.rowThisYear": "Dieses Jahr",
  "panel.rowThisWeek": "Diese Woche",
  "panel.rowToday": "Heute",

  "panel.totalCombined": "Gesamt kombiniert:",
  "panel.totalSupport": "Gesamte Unterstützung:",

  "panel.paymentMethod": "Zahlungsmethode",
  "panel.noPaymentMethod": "Derzeit ist keine Zahlungsmethode verfügbar.",
  "panel.supportAmount": "Unterstützungsbetrag (EUR)",
  "panel.amountRange": "Der Betrag sollte zwischen {min} und {max} liegen.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Geschätzte bezahlte Klicks:",
  "panel.ratioInfo":
    "Verhältnis: {a} = {b} Klicks (z. B. {c} = {d} Klicks). Dies ist nur eine Schätzung vor der Zahlung - die endgültige Klickzahl wird immer vom Server anhand der tatsächlich bestätigten Zahlung berechnet und bestätigt.",
  "panel.preparing": "Wird vorbereitet …",
  "panel.continueWith": "Weiter mit {provider}",
  "panel.choosePaymentMethod": "Wähle eine Zahlungsmethode",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME ist nicht gesetzt - siehe README zur Konfiguration.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID ist nicht gesetzt - siehe README zur Konfiguration.",

  "panel.paypalAmountInfo": "Betrag: {amount} (geschätzt {clicks} Klicks). Schließe die Zahlung mit dem PayPal-Button unten ab.",
  "panel.back": "← Zurück",

  "panel.bmcWarningTitle": "⚠️ Bevor du zu BuyMeCoffee weitergehst:",
  "panel.bmcWarningBody":
    "Füge den Code unten beim Checkout in das Nachrichten-/Notizfeld ein — nur so wissen wir, welches Land du unterstützt. Ohne den Code können wir die Zahlung keinem Land zuordnen.",
  "panel.copy": "Kopieren",
  "panel.copied": "Kopiert ✓",
  "panel.suggestedAmount": "Vorgeschlagener Betrag:",
  "panel.bmcAmountNote":
    "(geschätzt {clicks} Klicks). BuyMeCoffee unterstützt leider keine Übergabe des Betrags per Link — gib ihn selbst auf der Website ein oder wähle ihn dort aus. Die tatsächliche Klickzahl wird immer aus dem Betrag berechnet, den du tatsächlich bei BuyMeCoffee sendest, nicht aus dieser Schätzung.",
  "panel.openBmc": "BuyMeCoffee öffnen und fortfahren →",
  "panel.waitingProvider": "Warten auf Zahlungsbestätigung vom Zahlungsanbieter …",
  "panel.waitingConfirmation": "Warten auf Zahlungsbestätigung …",
  "panel.timedOut":
    "Die Überprüfung hat das Zeitlimit überschritten. Wenn du die Zahlung abgeschlossen hast, wird die Karte aktualisiert, sobald der Server die Bestätigung erhält - das kann manchmal etwas länger dauern.",
  "panel.checkAgain": "Erneut prüfen",

  "panel.cancelled": "Die Zahlung wurde abgebrochen oder ist fehlgeschlagen. Die Karte hat sich nicht geändert.",
  "panel.tryAgain": "Erneut versuchen",

  "panel.confirmed": "✅ Unterstützung bestätigt!",
  "panel.confirmedBody": "{country} hat {clicks} bezahlte Klicks für {amount} erhalten.",

  "panel.errorPreparingSupport": "Fehler beim Vorbereiten deiner Unterstützung.",
  "panel.errorPreparingPayment": "Fehler beim Vorbereiten der Zahlung.",
  "panel.errorConfirmingPayment": "Fehler beim Bestätigen der Zahlung.",
  "panel.errorPayingPaypal": "Fehler bei der Zahlung mit PayPal.",

  "share.unranked": "{flag}{country} braucht deine Unterstützung auf der Weltkarte!\nHilf mit, in der Rangliste aufzusteigen 👇",
  "share.rank1": "{flag}{country} ist aktuell #1!\nHilf uns, an der Spitze zu bleiben 👇",
  "share.rankN": "{flag}{country} ist aktuell #{rank}!\nHilf uns, #1 zu erreichen 👇",

  "language.switcherLabel": "Sprache",
};

export default de;
